import React, { useState, useEffect } from 'react';
import onBoardImg from "../../../assets/images/onboarding.png";
import Logo from '../../../images/logo-dark.png';
import { Button } from 'reactstrap';
import { Steps, StepsProvider, useSteps } from "react-step-builder";
import StepForm from './StepForm';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Api from '../../../Api';

const OnBoarding = () => {
  const [formShow, setFormShow] = useState(false);

  useEffect(() => {
    AOS.init();
  }, [])

  const handleChangeForm = async(eve) => {
    await Api.OnboardAuthToken();
    setFormShow(!formShow);
  }



  return (
    <>
      {!formShow &&
        <>
          <div className='position-absolute p-3'>
            <img src={Logo} alt='' className='object-fit-contain w-250px h-50 d-block mx-auto' />
          </div>
          <div className='position-fixed top-50 start-50 translate-middle'>
            <div>
              <div className='text-center mb-xl-5' data-aos="flip-left" data-aos-duration="2000">
                <img src={onBoardImg} alt='' className='object-fit-contain w-200px h-50 d-block mx-auto' />
                <h1 className=' onboard_head gradient_text fw-bold'>Welcome!</h1>
              </div>
              <div className='text-center'>
                <p className='pt-1 pb-2 fs-7 fw-normal text-center mx-auto'>
                <span className='fw-bold fs-4 gradient_text'>Introducing RingRemind's Al-powered lead conversion platform </span> <br />your ultimate tool for selling, scheduling, communicating, and accepting payments from customers 24/7. <br /> Effortlessly streamline your operations and enhance customer engagement around the clock.
                </p>
                {/* <Button color="primary" size="lg" onClick={eve=> handleChangeForm(eve)}>Start Now</Button> */}
                <button className="onBoardButton onBoard_btn hover_filled_slide_right " onClick={eve => handleChangeForm(eve)}><span className='fw-bold'>Start Now</span></button>
              </div>
            </div>
          </div>
        </>
      }
      {formShow && <StepForm />}

    </>
  )
}

export default OnBoarding;